import { faFacebookF, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WalletIcon } from "@heroicons/react/20/solid";
import { t } from "i18next";
import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import OR_Logo_Transparent from '../../../assets/OR_Logo_Transparent.png';
import i18n from "../../../i18n";
import { formatCAD } from "../../../utils/currencyFormatHelper";
import { setRouteParam } from "../../../utils/routeHelper";
import LanguageChanger from "../../languageChanger/LanguageChanger";
import Logo from '../logo/logo';
import './LandingPage.css';
export interface LandingPage {
    children?: any
}

const LandingPage: React.FC<LandingPage> = ({
    children,
}) => {
    const urlParameters = new URLSearchParams(window.location.search)
    const location = (urlParameters.get('prov') ? urlParameters.get('prov') : 'ON')
    const language = Number(urlParameters.get('lang') ? urlParameters.get('lang') : "0")
    const orgGuid = urlParameters.get('og') ? urlParameters.get('og')?.toString() : ''
    const cost = location === 'MB' ? formatCAD(42, language) : formatCAD(33, language)
    useEffect(() => {
        window.scrollTo(0, 0)
        i18n.changeLanguage(language === 0 ? 'enUS' : 'frCA')
    }, [language])
    const handleLanguageChange = () => {
        const langChange = language === 0 ? 1 : 0
        const lang = langChange === 0 ? 'enUS' : 'frCA'
        i18n.changeLanguage(lang)
        setRouteParam(location || '', langChange)
    }
    const getUrl = (provinceId: string, name: string) => {
        if (name === 'planDetails') return provinceId === 'MB' ? t('url_mb') : t('url_others')
        if (name === 'aboutUs') return provinceId === 'MB' ? t('url_mb_aboutUs') : t('url_others_aboutUs')
        if (name === 'whatIsInsuremykids') return provinceId === 'MB' ? t('url_mb_whatIsInsuremykids') : t('url_others_whatIsInsuremykids')
        if (name === 'ourPlans') return provinceId === 'MB' ? t('url_mb_ourPlans') : t('url_others_ourPlans')
        if (name === 'policy') return provinceId === 'MB' ? t('url_mb_policy') : t('url_others_policy')
        if (name === 'termsOfUse') return provinceId === 'MB' ? t('url_mb_termsOfUse') : t('url_others_termsOfUse')
        if (name === 'privacy') return provinceId === 'MB' ? t('url_mb_privacy') : t('url_others_privacy')
        if (name === 'complaintProcedures') return provinceId === 'MB' ? t('url_mb_complaintProcedures') : t('url_others_complaintProcedures')
        if (name === 'accessibility') return provinceId === 'MB' ? t('url_mb_accessibility') : t('url_others_accessibility')
        if (name === 'unclaimedProperty') return provinceId === 'MB' ? t('url_mb_unclaimedProperty') : t('url_others_unclaimedProperty')
        if (name === 'fileAClaim') return provinceId === 'MB' ? t('url_mb_fileAClaim') : t('url_others_fileAClaim')
        if (name === 'resources') return provinceId === 'MB' ? t('url_mb_resources') : t('url_others_resources')
        if (name === 'FAQs') return provinceId === 'MB' ? t('url_mb_FAQs') : t('url_others_FAQs')
        if (name === 'contactUs') return provinceId === 'MB' ? t('url_mb_contactUs') : t('url_others_contactUs')
        if (name === 'orican') return t('url_orican')
    }

    return (
        <div>
            {/* Montserrat Font */}
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" />
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />

            {/* Section1: LOGO */}
            <div className="top-border body-border-shadow flex">
                <div className='relative bg-white w-full top-0 z-50 fixed h-auto shadow-md flex flex-row justify-between sm:justify-center'>
                    <div className='flex sm:justify-center'>
                        <div className='flex my-1 float-left ml-3 sm:ml-0'>
                            <Logo width={225} height={100} />
                        </div>
                        <div className="flex right-2 xs:absolute md:right-5 lg:pr-8 pt-2">
                            <LanguageChanger
                                handleClick={handleLanguageChange}
                                selectedLang={language}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 2: Accidents Happen */}
            <div className="flex flex-col relative bg-[#0075c9] xs:h-[1000px] h-[1250px] md:h-[800px] lg:h-[700px]" >
                {/* Section2_1: BG z-0 (Path Line) */}
                <div className="h-1/3 z-0">
                    <div className="relative h-full">
                        <div
                            className=""
                            style={{ opacity: 0.5 }}
                        >
                            <svg
                                className="absolute inset-0 w-full h-full "
                                viewBox="0 0 240 24"
                                preserveAspectRatio="none"
                            >
                                <style nonce="rAnd0m">
                                    {`
          .fill-white {
            fill: #ffffff;
          }
          .fill-white-opacity-33 {
            fill-opacity: 0.33;
          }
        `}
                                </style>
                                <path
                                    className="fill-white fill-white-opacity-33"
                                    d="M0,0v24L240,0H0z"
                                ></path>
                                <path className="fill-white" d="M0,0v20.279L240,0H0z"></path>
                                <path
                                    className="fill-white fill-white-opacity-33"
                                    d="M0,0v22.01L240,0H0z"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="h-1/3 z-0"></div>
                <div className="h-1/3 z-20">
                    <div className="relative h-full ">
                        <div
                            className=""
                            style={{ opacity: 1 }}
                        >
                            <svg
                                className="absolute inset-0 w-full h-full"
                                viewBox="0 0 240 24"
                                preserveAspectRatio="none"
                            >
                                <style nonce="rAnd0m">
                                    {`
          .fill-white {
            fill: #ffffff;
          }
          .fill-white-opacity-33 {
            fill-opacity: 0.33;
          }
        `}
                                </style>
                                <path
                                    className="fill-white fill-white-opacity-33"
                                    d="M0,24V0L240,24H0z"
                                ></path>
                                <path className="fill-white" d="M0,24V3.72L240,24H0z"></path>
                                <path
                                    className="fill-white fill-white-opacity-33"
                                    d="M0,24V1.99L240,24H0z"
                                ></path>
                            </svg>
                        </div>
                    </div>
                </div>
                {/* Section2_2: Kids(3) Picture(left) + BUY PLAN(right) */}
                <div className="absolute flex-col lg:flex-row w-full top-0 left-0 flex">
                    <div className="lg:w-1/2 pt-[36px] relative">
                        <div className="h-full flex items-center justify-center">
                            <img
                                src={require('../../../assets/Insured.png')}
                                alt="Insured"
                                className="max-w-[200px] lg:max-w-[500px] lg:max-h-[700px] object-contain"
                            />
                        </div>
                    </div>
                    <div className="w-full px-[36px] lg:w-1/2 lg:pl-[18px] lg:pr-[40px] lg:pt-[20px] z-50">
                        <div className="lg:pr-[40px] lg:pt-[20px]" >
                            <div className="lg:pr-[40px]">
                                <div className="flex flex-col text-center lg:text-left">
                                    <div className="pt-[18px] text-[28px] font-bold text-white">{t('accidentsHappen')}</div>
                                    <div className="mt-[36px]">
                                        <div className="text-white text-[18px]">{t('whetherOnSchool')}</div>
                                        <div className="text-white mt-[36px] text-[18px] ">{location === "MB" ? t('mb_stayProtected') : t('stayProtected')}</div>
                                        <br></br>
                                        <br></br>
                                        <div className="text-zinc-200 text-[24px] font-bold ">{t('accidentCoverage')} {cost} </div>
                                        <p></p>
                                        <div className="p-3 flex items-center justify-center lg:justify-start">
                                            <Link to={`./policybooking?prov=${location}&lang=${language}&og=${orgGuid}`}>
                                                <div className='border-2 border-[#0075c9] pt-2 active:bg-[#9ccb45] focus:bg-[#9ccb45] outline-none focus: bg-white w-56 h-11 hover:bg-[#0075c9] font-bold mt-3 mb-3 hover:text-white hover:outline-white text-black text-lg justify-center text-center'>{t('buyPlan')}</div>
                                            </Link>
                                        </div>
                                        <div className="lg:pt-[36px]"></div>
                                        <div className="pt-[36px]"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Section 3: Even small accidents come with large bills */}
            <div className='flex flex-row lg:flex-col '>
                <div className="flex flex-col lg:flex-row">
                    <div className="lg:w-2/4 p-[18px] lg:p-[38px] xs:p-[58px] xxl:p-[108px]">
                        <div className="text-[#0075c9] text-[28px] md:text-[42px]">{t('smallAccidentsWithBills')}</div>
                        <div className="mt-[36px] text-[12px] md:text-[16px]">
                            <div>{t('coverageFor')}</div>
                            <ul className="list-disc pl-[18px] mt-[18px]">
                                <li>{t('dentalAccidents')}</li>
                                <li>{t('totalPermanentDisability')}</li>
                                <li>{t('fracturesAndDislocations')}</li>
                                <li>{t('ambulanceSurcharges')}</li>
                                <li>{t('hospitalRoomExpense')}</li>
                                <li>{t('paramedical')}</li>
                                <li>{t('muchMore')}</li>
                            </ul>

                        </div>
                    </div>
                    <div className="lg:w-1/4 relative bg-cover bg-no-repeat bg-center bg-[url('https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/indoor-playground-uai-258x258.jpg?time=1685718869')]" >
                        <div className="bg-black bg-opacity-50 bg-center h-full w-full">
                            <div className="z-50 relative p-[18px] lg:p-[38px] xs:p-[58px] xxl:p-[108px]">
                                <div className="text-white text-center items-center text-[28px]">{t('watchVideo')}</div>
                                <div className="flex mt-[36px] justify-center items-center p-[36px]">
                                    <a href="https://youtu.be/xFbYAP4vstY" target="_blank" aria-label="Watch Video for more info">

                                        <FontAwesomeIcon icon={faYoutube} className="opacity-80 text-white text-sm md:text-md w-full h-full lg:text-lg transition-all duration-300 hover:filter hover:blur-[5px]" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/4 bg-cover bg-no-repeat bg-center bg-[url('https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/break-the-bank.jpg')]">
                        <div className="bg-white bg-opacity-80 bg-center h-full w-full">
                            <div className="p-[18px] xs:p-[58px] lg:p-[38px] xxl:p-[108px] ">
                                <div className="justify-center items-center">
                                    <div className="flex justify-center items-center">
                                        <a
                                            href="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/break-the-bank.jpg"
                                            target="_blank"
                                            aria-label="Don't break the bank on unexpected costs"
                                        >
                                            <div className="w-[90px]">
                                                <WalletIcon className="text-[#0075c9] opacity-100" />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="icon-box-content">
                                        <div className="icon-box-heading icon-box-fa-5x">
                                            <div className="text-[28px] text-[#0075c9] text-center font-bold">{t('dontBreakCosts')}</div>
                                        </div>
                                        <div className="text-[12.8px] text-center">
                                            {t('healthPlanWorkPlan')}
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/* Section 4: 24/7 Coverage section */}
            <div className='bg-[#e38026] flex justify-center items-center'>
                <div className='max-w-[1200px] xs:p-9'>
                    <div className='lg:p-9'>
                        <div className=''>
                            <div className='flex flex-col lg:flex-row lg:ml-[-36px]'>
                                <div className='flex-col lg:flex-row lg:w-2/6 lg:pl-[36px]'>
                                    <div className='text-black text-center text-[42px] font-bold lg:text-left'>{t('24Coverage')}</div>
                                    <div></div>
                                    <div className="flex justify-center items-center lg:justify-start ">
                                        <a
                                            href={getUrl(
                                                location || '', 'planDetails'
                                            )}
                                            target="_blank"
                                            className="pt-4 text-lg text-sky-700 text-center"
                                        >
                                            <div className='pt-2 bg-white text-black active:bg-[#e38026] outline-none focus:bg-white w-56 h-11 hover:bg-[#e38026] hover:outline-white font-bold mt-3 mb-3 hover:text-white text-lg justify-center text-center '>{t('learnMore')}</div>
                                        </a>
                                    </div>

                                </div>
                                <div className='lg:w-1/6 lg:pl-[36px]'>
                                    <div className=''></div>
                                </div>
                                <div className='lg:w-3/6 text-[15px] text-center lg:text-left lg:text-[18px] pl-[8px] xs:pl-[36px] text-black justify-center items-centers'>{location === "MB" ? t('mb_insuremykidsProtectsFamily') : t('insuremykidsProtectsFamily')}</div>
                            </div>
                            <div className="h-[36px]" />
                            <div className='flex flex-col justify-center items-center sm:flex-row sm:flex-wrap lg:flex-nowrap lg:flex-row lg:ml-[-36px] lg:mt-[18px]'>
                                <img className="lg:ml-[36px] mt-[18px] sm:p-[36px] lg:p-[0px] sm:w-1/2 lg:w-1/4" src="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/trampoline-park-uai-193x258.jpg?time=1685718869" width={193} height={258} alt="" data-uniqueid="2624-530984" data-guid="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/trampoline-park.jpg" data-path="2023/04/trampoline-park.jpg" data-width={800} data-height={800} data-singlew={3} data-singleh={4} data-crop={1} data-fixed />
                                <img className="lg:ml-[36px] mt-[18px] sm:p-[36px] lg:p-[0px] sm:w-1/2 lg:w-1/4" src="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/kids-hockey-league-uai-193x258.jpg?time=1685718869" width={193} height={258} alt="" data-uniqueid="2622-158426" data-guid="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/kids-hockey-league.jpg" data-path="2023/04/kids-hockey-league.jpg" data-width={800} data-height={800} data-singlew={3} data-singleh={4} data-crop={1} data-fixed />
                                <img className="lg:ml-[36px] mt-[18px] sm:p-[36px] lg:p-[0px] sm:w-1/2 lg:w-1/4" src="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/indoor-playground-uai-193x258.jpg?time=1685718869" width={193} height={258} alt="" data-uniqueid="2614-213666" data-guid="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/indoor-playground.jpg" data-path="2023/04/indoor-playground.jpg" data-width={800} data-height={800} data-singlew={3} data-singleh={4} data-crop={1} data-fixed />
                                <img className="lg:ml-[36px] mt-[18px] sm:p-[36px] lg:p-[0px] sm:w-1/2 lg:w-1/4" src="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/indoor-rock-climbing-uai-193x258.jpg?time=1685718869" width={193} height={258} alt="" data-uniqueid="2616-185100" data-guid="https://ug9cb6.p3cdn1.secureserver.net/wp-content/uploads/2023/04/indoor-rock-climbing.jpg" data-path="2023/04/indoor-rock-climbing.jpg" data-width={800} data-height={800} data-singlew={3} data-singleh={4} data-crop={1} data-fixed />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer 1: Follow us on FB */}
            <div className='bg-[#0075c9] flex justify-center items-center'>
                <div className='max-w-[1200px] py-[25px] mx-auto'>
                    <div className='text-[15px] text-center lg:text-[22px] text-white py-[20px]'>{t('greatRelationshipStartsWithConversation')}<strong>{t('followUs')}</strong> <span><a href="https://www.facebook.com/InsureMyKids" target="_blank"><FontAwesomeIcon icon={faFacebookF} className="hover:text-[#e38026]" /><i className="fa fa-facebook" title="Visit our Facebook (opens in New Tab)" />&nbsp;</a> <a href="https://twitter.com/insuremykids" target="_blank"><FontAwesomeIcon icon={faTwitter} className="hover:text-[#e38026]" /><i className="fa fa-twitter" title="Visit our Twitter (opens in New Tab)" /></a></span></div>
                </div>
            </div>
            {/*Footer 2: About, Legal, Customer Care*/}
            <div className="bg-black text-white py-7 ">
                <div className="grid lg:grid-cols-5 md:grid-cols-3 grid-rows-1 md:items-start md:place-items-center justify-center md:text-left text-center ">
                    <div className="lg:col-start-2 md:col-start-1 space-y-5 md:w-[10rem]">
                        <div className="md:text-2xl text-xl font-bold ">
                            <h5>{t('about')}</h5>
                        </div>
                        <ul className="md:text-lg text-base">
                            <li className="hover:text-[#e38026]">
                                {/* <a href="https://insuremykids.com/about-us/" target="_blank">{t('aboutUs')}</a> */}
                                <a
                                    href={getUrl(
                                        location || '', 'aboutUs'
                                    )}
                                    target="_blank"
                                >
                                    {t('aboutUs')}
                                </a>
                            </li>
                            <li className="hover:text-[#e38026]">
                                <a
                                    href={getUrl(
                                        location || '', 'whatIsInsuremykids'
                                    )}
                                    target="_blank"
                                >
                                    {location === "MB" ? t('mb_whatIsInsuremykids') : t('whatIsInsuremykids')}
                                    {location === "MB" ? <></> : <sup>®</sup>}
                                </a>
                            </li>
                            <li className="hover:text-[#e38026]">
                                <a
                                    href={getUrl(
                                        location || '', 'ourPlans'
                                    )}
                                    target="_blank"
                                >
                                    {t('ourPlans')}
                                </a>
                            </li>
                            <li className="hover:text-[#e38026]">
                                <a
                                    href={getUrl(
                                        location || '', 'policy'
                                    )}
                                    target="_blank"
                                >
                                    {t('policy')}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="lg:col-start-3 md:col-start-2 space-y-5 md:pt-0 pt-7">
                        <div className="md:text-2xl text-xl font-bold">
                            <h5><span>{t('legal')}</span></h5>
                        </div>
                        <div>
                            <ul className="md:text-lg text-base">
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'termsOfUse'
                                        )}
                                        target="_blank"
                                    >
                                        {t('termsOfUse')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'privacy'
                                        )}
                                        target="_blank"
                                    >
                                        {t('privacy')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'complaintProcedures'
                                        )}
                                        target="_blank"
                                    >
                                        {t('complaintProcedures')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'accessibility'
                                        )}
                                        target="_blank"
                                    >
                                        {t('accessibility')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'unclaimedProperty'
                                        )}
                                        target="_blank"
                                    >
                                        {t('unclaimedProperty')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="lg:col-start-4 md:col-start-3 space-y-5 md:pt-0 pt-7">
                        <div className="md:text-2xl text-lg font-bold">
                            <h5>{t('customerCare')}</h5>
                        </div>
                        <div>
                            <ul className="md:text-lg text-base">
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'fileAClaim'
                                        )}
                                        target="_blank"
                                    >
                                        {t('fileAClaim')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'resources'
                                        )}
                                        target="_blank"
                                    >
                                        {t('resources')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'FAQs'
                                        )}
                                        target="_blank"
                                    >
                                        {t('FAQs')}
                                    </a>
                                </li>
                                <li className="hover:text-[#e38026]">
                                    <a
                                        href={getUrl(
                                            location || '', 'contactUs'
                                        )}
                                        target="_blank"
                                    >
                                        {t('contactUs')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* Footer 3: Old Republic Canada */}
            <div className="flex justify-center bg-[#f2f2f2]">
                <div className="flex flex-col lg:flex-row w-[1200px]">
                    <div className="w-full lg:w-1/3 p-[11px] lg:p-[20px]">
                        <div className="flex justify-center items-center">
                            <a
                                href={getUrl(
                                    location || '', 'orican'
                                )}
                                title="Visit Old Republic"
                            >
                                <div id="icon-525880" ><img className="w-[15rem]" decoding="async" src={OR_Logo_Transparent} alt="Old Republic Logo" /></div>
                            </a>
                        </div>
                    </div>
                    <div className="w-full lg:w-2/3 p-[18px] lg:p-[36px]">
                        <div className="font-medium text-[0.7rem] text-center lg:text-right">
                            <p>{t('underwrittenByORI')}</p>
                            <p>© {t('ORIofCa')}</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default withTranslation()(LandingPage)